module.exports = __webpack_public_path__ + "704c52f220c4e9920266fc1980568ca2.svg";